import React, { useState } from 'react';
import { UploadIcon, CheckCircleIcon, HelpCircleIcon } from 'lucide-react';
import { Accordion } from './ui/Accordion';
import { Zone } from '../utils/types';
interface HouseZonesProps {
  zones: Zone[];
  selectedZone: Zone | null;
  onZoneSelect: (zone: Zone) => void;
}
export function HouseZones({
  zones,
  selectedZone,
  onZoneSelect
}: HouseZonesProps) {
  const [aiProcessed, setAiProcessed] = useState(false);
  const handleAiExtract = () => {
    setAiProcessed(true);
  };
  return <Accordion title="Hus & Zoner (AI-hjælp)" defaultOpen={true} data-id="element-131">
      <div className="space-y-4" data-id="element-132">
        {/* Upload field */}
        <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-red-300 transition-colors cursor-pointer" data-id="element-133">
          <div className="flex flex-col items-center" data-id="element-134">
            <UploadIcon className="h-10 w-10 text-gray-400 mb-3" data-id="element-135" />
            <p className="text-gray-600 mb-1" data-id="element-136">
              Drag & Drop PDF/DWG/IFC filer her
            </p>
            <p className="text-xs text-gray-500" data-id="element-137">
              eller klik for at vælge filer
            </p>
          </div>
        </div>
        {/* AI Extract button */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-138">
          <button className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg flex items-center justify-center transition-colors" onClick={handleAiExtract} data-id="element-139">
            <span className="mr-2" data-id="element-140">AI: Udtræk zoner/rum</span>
          </button>
          {aiProcessed && <div className="bg-green-50 text-green-700 px-3 py-1.5 rounded-lg text-sm flex items-center" data-id="element-141">
              <CheckCircleIcon className="h-4 w-4 mr-2" data-id="element-142" />
              <span data-id="element-143">Fundet: Storey 1/2, 12 rum • Kvalitet 92%</span>
            </div>}
        </div>
        {/* Zone chips */}
        {aiProcessed && <div className="mt-4" data-id="element-144">
            <div className="flex flex-wrap gap-2 mb-4" data-id="element-145">
              {zones.map(zone => <button key={zone.id} className={`px-3 py-1.5 rounded-lg text-sm transition-colors ${selectedZone?.id === zone.id ? 'bg-red-100 text-red-700 border border-red-200' : 'bg-white text-gray-700 border border-gray-200 hover:border-red-200'}`} onClick={() => onZoneSelect(zone)} data-id="element-146">
                  {zone.name} {zone.area} m²
                </button>)}
            </div>
            {/* Mini floor plan */}
            <div className="mt-4 bg-white p-4 rounded-xl border border-gray-200" data-id="element-147">
              <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-148">
                Plantegning
              </h3>
              <div className="bg-gray-100 rounded-lg h-48 flex items-center justify-center relative" data-id="element-149">
                <div className="absolute inset-0 rounded-lg overflow-hidden" data-id="element-150">
                  <img src="https://images.unsplash.com/photo-1574362848149-11496d93a7c7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Plantegning" className="w-full h-full object-cover opacity-20" data-id="element-151" />
                  {/* Colored zones overlaid on the floor plan */}
                  <div className="absolute top-[30%] left-[20%] w-[25%] h-[30%] bg-red-200 bg-opacity-50 rounded-md border border-red-400" data-id="element-152"></div>
                  <div className="absolute top-[30%] left-[50%] w-[15%] h-[20%] bg-blue-200 bg-opacity-50 rounded-md border border-blue-400" data-id="element-153"></div>
                  <div className="absolute top-[65%] left-[25%] w-[20%] h-[15%] bg-green-200 bg-opacity-50 rounded-md border border-green-400" data-id="element-154"></div>
                  <div className="absolute top-[60%] left-[55%] w-[20%] h-[25%] bg-yellow-200 bg-opacity-50 rounded-md border border-yellow-400" data-id="element-155"></div>
                </div>
                <span className="text-gray-500 text-sm" data-id="element-156">
                  Interaktiv plantegning (thumbnail)
                </span>
              </div>
            </div>
            {/* Tooltip glossary */}
            <div className="mt-4 flex flex-wrap gap-2 text-xs text-gray-500" data-id="element-157">
              <div className="flex items-center" data-id="element-158">
                <HelpCircleIcon className="h-3 w-3 mr-1" data-id="element-159" />
                <span data-id="element-160">manifold: Fordelerrør til gulvvarme</span>
              </div>
              <div className="flex items-center" data-id="element-161">
                <HelpCircleIcon className="h-3 w-3 mr-1" data-id="element-162" />
                <span data-id="element-163">c/c: Center-til-center afstand</span>
              </div>
              <div className="flex items-center" data-id="element-164">
                <HelpCircleIcon className="h-3 w-3 mr-1" data-id="element-165" />
                <span data-id="element-166">ΔT: Temperaturændring</span>
              </div>
              <div className="flex items-center" data-id="element-167">
                <HelpCircleIcon className="h-3 w-3 mr-1" data-id="element-168" />
                <span data-id="element-169">AP: Tryk</span>
              </div>
            </div>
          </div>}
      </div>
    </Accordion>;
}